import React from 'react';
import { string, bool } from 'prop-types';

const getDeliveryDatePrice = ({ isDeliveryTimelineTodayOrTomorrow, deliveryDateAvailability }) => {
  let displayDeliveryDatePrice = '';
  if (isDeliveryTimelineTodayOrTomorrow) {
    displayDeliveryDatePrice = `As soon as ${deliveryDateAvailability.toLowerCase()}`;
  } else {
    displayDeliveryDatePrice = 'Get it faster';
  }

  return displayDeliveryDatePrice;
};

const getShipModeDetails = ({ isDeliveryTimelineTodayOrTomorrow, deliveryDateAvailability }) => {
  let displayShipmentDeliveryDetails = '';
  if (isDeliveryTimelineTodayOrTomorrow) {
    displayShipmentDeliveryDetails = `Get your order delivered ${deliveryDateAvailability.toLowerCase()},
    or schedule which day is best.`;
  } else {
    displayShipmentDeliveryDetails = 'Schedule which day is best.';
  }

  // display delivery message
  return `${displayShipmentDeliveryDetails} Choose a 2- or 4-hour window for an added charge.`;
};

const DeliverFromStore = ({
  isDeliveryTimelineTodayOrTomorrow,
  deliveryDateAvailability,
  shipCharge
}) => (

  <>
    <div className="datePriceRow">
      <span className="left date dots">
        {getDeliveryDatePrice({
          isDeliveryTimelineTodayOrTomorrow,
          deliveryDateAvailability
        })}
      </span>

      <span className="right price">
        <span className="" />
        {shipCharge}/order
      </span>

      <div className="shipModeRow">
        <div className="shipmentModeDescription">
          {getShipModeDetails({
            isDeliveryTimelineTodayOrTomorrow,
            deliveryDateAvailability
          })}
        </div>
      </div>

    </div>
  </>
);

DeliverFromStore.propTypes = {
  deliveryDateAvailability: string,
  isDeliveryTimelineTodayOrTomorrow: bool,
  shipCharge: string
};

DeliverFromStore.defaultProps = {
  deliveryDateAvailability: null,
  isDeliveryTimelineTodayOrTomorrow: null,
  shipCharge: null
};

export { DeliverFromStore };